import React, { useEffect } from 'react'
import moment from 'moment'
import type { Moment } from 'moment'

import DatePicker from '../components/DatePicker'

export type DatePickerModalProps = {
  date: Moment
  maxDate?: Moment
  onChange: (date: Moment) => void
  closeModal?: () => void
}

export default function DatePickerModal({
  onChange,
  closeModal,
  date,
  maxDate: initialMaxDate,
}: DatePickerModalProps) {
  const [selectedDate, setSelectedDate] = React.useState<Moment>(date)
  const [valid, setValid] = React.useState<boolean>(true)
  const [maxDate, setMaxDate] = React.useState<Moment | null>(
    initialMaxDate ?? null,
  )

  useEffect(() => {
    // Fetch max bookable date from API
    void fetch('https://api.miniatur-wunderland.de/v1/maxDate/', {
      method: 'GET',
      mode: 'cors',
    })
      .then((response) => {
        return response
          .json()
          .then((data: { maxDate: string }) => {
            setMaxDate(moment(data.maxDate, 'YYYY-MM-DD'))
          })
          .catch((e) => {
            console.warn(e)
          })
      })
      .catch((e) => {
        console.warn(e)
      })
  }, [])

  const isOverMaxDate =
    maxDate !== null && selectedDate.diff(maxDate, 'days') > 0

  useEffect(() => {
    const nextValid =
      selectedDate.isValid() &&
      (maxDate === null || selectedDate.diff(maxDate, 'days') <= 0)
    setValid(nextValid)
  }, [maxDate, selectedDate])

  return (
    <div className="ModalDatePicker">
      <div className="ModalDatePicker__HeadlineContainer">
        <div className="ModalDatePicker__Headline">
          {window.jsProps.strings.chooseDate}
        </div>
      </div>
      <div className="ModalDatePicker__DatePickerContainer">
        <DatePicker
          initialDate={selectedDate}
          maxDate={maxDate}
          valid={valid}
          errorMessage={
            isOverMaxDate
              ? window.jsProps.strings.maxDate
              : window.jsProps.strings.invalidDate
          }
          onChange={(e: Moment) => {
            const nextValid =
              e.isValid() && (maxDate === null || e.diff(maxDate, 'days') <= 0)
            setValid(nextValid)
            if (!nextValid) {
              setSelectedDate(e.isValid() ? e : selectedDate)
              return
            }
            setSelectedDate(e)
            onChange(e)
            closeModal?.()
          }}
        />
      </div>
    </div>
  )
}
